type ProvidersGrid = {
  init: () => void;
};

const ProvidersGrid: ProvidersGrid = {
  init() {
    const providersGrid = document.querySelector('[data-hook=providersGrid]') as HTMLElement;
    if (!providersGrid) return;

    const moreButton = providersGrid.querySelector('[data-hook=providersGrid__moreButton]') as HTMLElement;
    if (!moreButton) return;

    let props: any;
    if (providersGrid.dataset.props) {
      try {
        props = JSON.parse(providersGrid.dataset.props);
      } catch (error) {
        console.warn('ProvidersGrid: failed to parse data-props JSON', error);
      }
    }

    const notificationMessage = providersGrid.querySelector('[data-hook=providersGrid__notificationMessage]') as HTMLElement | null;
    const hiddenProviders = providersGrid.querySelectorAll('li.is-hidden') as NodeListOf<HTMLLIElement>;
    const ctaLink = providersGrid.querySelector('[data-hook=providersGrid__ctaLink]') as HTMLElement | null;

    moreButton?.addEventListener('click', () => {
      hiddenProviders.forEach((item) => {
        item.classList.remove('is-hidden');
      });
      if (notificationMessage) {
        notificationMessage.textContent = props?.resourceStrings?.notificationMessage ?? '';
        moreButton.style.display = 'none';
      }
      if (ctaLink) {
        ctaLink.hidden = false;
      }
      // Move focus to the first newly-revealed provider for keyboard/SR users, but pass
      // preventScroll so the browser doesn't auto-scroll it into view. A default focus()
      // scrolls the (below-fold) first hidden provider to the top, dragging the visible top
      // rows up under the sticky app-header and clipping their images. The revealed items
      // appear right where the "More" button was (bottom of viewport), so focus stays visible.
      hiddenProviders[0]?.querySelector<HTMLAnchorElement>('a')?.focus({ preventScroll: true });
    });
  },
};
export default ProvidersGrid;